import request from '@/utils/request'

export function getProducts(data) {
	return request({
		url: '/open/product',
		method: 'get',
		params: data
	})
}
